export { default } from "./getCountryData";
